import { dponet, dpoeasy, marketplace, external } from './modules'

const service = { dponet, dpoeasy, marketplace, external }

export default service
